/**
 * @generated SignedSource<<27855a7da5f01d0d0fe98c521bc0924a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type LessonSkillsFilterInput = {
  isActive?: boolean | null | undefined;
  lessonNames?: ReadonlyArray<string | null | undefined> | null | undefined;
  lessonTypeIds?: ReadonlyArray<string> | null | undefined;
  skillId?: string | null | undefined;
};
export type SkillsLessonByTypeQuery$variables = {
  filter: LessonSkillsFilterInput;
};
export type SkillsLessonByTypeQuery$data = {
  readonly lessonSkills: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly isActive: boolean;
      readonly lesson: {
        readonly id: string;
        readonly name: string | null | undefined;
        readonly spanishUrl: string | null | undefined;
        readonly summary: string | null | undefined;
        readonly teacherOnly: boolean;
        readonly type: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly url: string | null | undefined;
      } | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type SkillsLessonByTypeQuery = {
  response: SkillsLessonByTypeQuery$data;
  variables: SkillsLessonByTypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Literal",
        "name": "order",
        "value": [
          {
            "lesson": {
              "type": {
                "name": "ASC"
              }
            }
          }
        ]
      }
    ],
    "concreteType": "LessonSkillNodeConnection",
    "kind": "LinkedField",
    "name": "lessonSkills",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LessonSkillNode",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LessonNode",
            "kind": "LinkedField",
            "name": "lesson",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "teacherOnly",
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "summary",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "spanishUrl",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LessonTypeNode",
                "kind": "LinkedField",
                "name": "type",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SkillsLessonByTypeQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SkillsLessonByTypeQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "eb550ea4b25a4ded1eadb633900c736c",
    "id": null,
    "metadata": {},
    "name": "SkillsLessonByTypeQuery",
    "operationKind": "query",
    "text": "query SkillsLessonByTypeQuery(\n  $filter: LessonSkillsFilterInput!\n) {\n  lessonSkills(filter: $filter, order: [{lesson: {type: {name: ASC}}}]) {\n    nodes {\n      id\n      isActive\n      lesson {\n        teacherOnly\n        id\n        summary\n        url\n        spanishUrl\n        name\n        type {\n          name\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4997bbb52c500f7e07650dfeb1c0fecf";

export default node;
